export const OPERATIONAL_PERMISSIONS = {
  LOYALTY_TRANSACTIONS: 'loyalty_transactions',
  LOYALTY_ADDITIONS_DEDUCTIONS: 'loyalty_additions_and_deductions',
  LOYALTY_MANAGEMENT_REPORTING: 'loyalty_management_reporting',
};
